import { render, staticRenderFns } from "./IconPlus.vue?vue&type=template&id=138a5928&scoped=true&lang=pug"
import script from "./IconPlus.vue?vue&type=script&lang=js"
export * from "./IconPlus.vue?vue&type=script&lang=js"
import style0 from "./IconPlus.vue?vue&type=style&index=0&id=138a5928&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138a5928",
  null
  
)

export default component.exports